"use strict";
exports.__esModule = true;
var validateJivositeId = function (value, provider) {
    var regExp = provider === 'yandex' ? /^[a-z0-9\-]*$/i : /^[a-z0-9]*$/i;
    if (!value.match(regExp)) {
        return 'В данном поле могут быть только латинские буквы и цифры';
    }
    return '';
};
exports["default"] = validateJivositeId;
